import React, { useState, useRef, useEffect } from "react"
import Header from "./Header";
import Content from "./Content";
import Options from "./Options";
import { IoChatbubbleOutline, IoChatbubblesOutline } from "react-icons/io5";
import { IoClose } from "react-icons/io5";
import PageParrotLogo from "./PageParrotLogo";
import { useVisualizerContext } from "./Visualizer";
import { MSG_TYPE_ENUM } from './Message';
import useNotificationSound from "./useNotificationSound";
import { Timestamp } from "firebase/firestore";
import { LIMITS } from "../Limits";
const { AUTO_ENGAGE, WELCOME_MSG, DISABLED } = MSG_TYPE_ENUM;

function Chat() {
    const { 
        banned, 
        config, 
        messages, 
        addMessage, 
        open, 
        toggleOpen, 
        isContactEnabled, 
        isAutoReplyEnabled, 
        isWithinHours, 
        isDeadEmbed,
        activeVisualTrigger,
        setActiveVisualTrigger,
        updateSeen,
    } = useVisualizerContext();
    //const [data, loading, bad] = useThread();
    const [options, setOptions] = useState(0);
    const [isNewMessage, setIsNewMessage] = useState(false);
    const [showAutoReply, setShowAutoReply] = useState(false);
    const [isPlaying, error, play, stop] = useNotificationSound();

    useEffect(() => {
        if (messages && messages.length > 0) {
            const latestMessage = messages[messages.length - 1];
            if (latestMessage.msgType < 0 && !latestMessage.seen) {
                setIsNewMessage(true);
                if (!isPlaying) {
                    play();
                }
            }
            if (messages.length === 1 && (latestMessage.msgType === AUTO_ENGAGE || latestMessage.msgType === WELCOME_MSG)) {
                setShowAutoReply(isAutoReplyEnabled);
            }
        }
    }, [messages]);

    useEffect(() => {
        if (messages && messages.length > 0 && open) {
            const latestIndex = messages.length - 1;
            const latestMessage = messages[latestIndex];
            if (latestMessage.msgType < 0 && !latestMessage.seen) {
                latestMessage.seen = true;
                updateSeen(latestIndex, latestMessage.msgType);
                setIsNewMessage(false);
            }
        }
    }, [open, messages]);

    useEffect(() => {
        if (activeVisualTrigger === 'chat' || activeVisualTrigger === 'autoReply') {
            setOptions(0);
            toggleOpen(true);
        } else if (activeVisualTrigger === 'contact') {
            setOptions(1);
            toggleOpen(true);
        }
    }, [activeVisualTrigger]);

    useEffect(() => {
        if (!config.default && messages[0]?.msgType === DISABLED) {
            setShowAutoReply(false);
        }
    }, [config, messages]);

    if (activeVisualTrigger ? (activeVisualTrigger === 'bubble') : (isDeadEmbed || (!open && !isNewMessage))) { //plus config check and animation check for isNewMessage
        return (
            <IconButton toggleOpen={toggleOpen} addMessage={addMessage} config={config} messages={messages} isWithinHours={isWithinHours} isDeadEmbed={isDeadEmbed} clearTrigger={() => setActiveVisualTrigger(null)} />
        );
    }

    if (activeVisualTrigger ? (activeVisualTrigger === 'popup' || activeVisualTrigger === 'autoEngage') : (!open && isNewMessage)) {//plus config check? fix no implmentation of msg-popup-column
        const latestMessageIndex = messages.length - 1;
        const latestMessage = messages[latestMessageIndex];
        return (
            <ChatWindowPopup toggleOpen={toggleOpen} setIsNewMessage={setIsNewMessage} config={config} latestMessageIndex={latestMessageIndex} latestMessage={latestMessage} clearTrigger={() => setActiveVisualTrigger(null)} updateSeen={updateSeen} />
        );
    }

    return (
        <div className={`chat-window open`}>
            <Header toggleOpen={toggleOpen} config={config} clearTrigger={() => setActiveVisualTrigger(null)} />
            <Content options={options} showAutoReply={showAutoReply} setShowAutoReply={setShowAutoReply} />
            {(isContactEnabled || banned) && <Options options={options} setOptions={setOptions} banned={banned} clearTrigger={() => setActiveVisualTrigger(null)} />}
        </div>
    );
}

function ChatWindowPopup({ toggleOpen, setIsNewMessage, config, latestMessageIndex, latestMessage, clearTrigger, updateSeen }) {
    function getImageBubble() {
        function getDiv(icon) {
            return (
                <div className="chat-window-popup-img-bubble">
                    {icon}
                </div>
            );
        }
        if (config?.workspaceStyles?.iconSetting2) {
            const { workspaceStyles } = config;
            switch(workspaceStyles.iconSetting2.iconSetting) {
                case "choose":
                    switch(workspaceStyles.iconSetting2.selectedIcon) {
                        case "chat1":
                            return getDiv(<IoChatbubbleOutline className="chat-icon" />);
                        case "chat2":
                            return getDiv(<IoChatbubblesOutline className="chat-icon" />);
                        default:
                            return getDiv(<PageParrotLogo className="chat-icon-logo" />); // default parrot icon
                    }
                case "workspace":
                    switch(config?.workspaceType) {
                        case 0:
                            return getDiv((config?.icon?.image_132) ? <img src={config.icon.image_132} alt="workspace" className="chat-icon rounded" /> : <PageParrotLogo className="chat-icon-logo" />);
                        case 1:
                            return getDiv(config?.icon ? <img src={config.icon} alt="workspace" className="chat-icon rounded" /> : <PageParrotLogo className="chat-icon-logo" />);
                        case 2:
                            return getDiv(config?.icon ? <img src={`https://cdn.discordapp.com/icons/${config?.workspace}/${config.icon}`} alt="workspace" className="chat-icon rounded" /> : <PageParrotLogo className="chat-icon-logo" />);
                        default:
                            return getDiv(<PageParrotLogo className="chat-icon-logo" />);
                    }
                case "upload":
                    return getDiv(<img src={workspaceStyles.customIcon} alt="workspace" className="chat-icon rounded" />);
                case "off":
                    return;
                default:
                    return getDiv(<PageParrotLogo className="chat-icon-logo" />); // default parrot icon
            }
        }
    }

    function handleClick(type) {
        clearTrigger();
        if (type === 'open') {
            toggleOpen(true);
        } else if (type === 'close') {
            updateSeen(latestMessageIndex, latestMessage.msgType);
            setIsNewMessage(false);
        }
    }

    return (
        <>
            <div className="chat-window-popup">
                {getImageBubble()/**(config && config.icon && config.icon.image_132) ? <img src={config.icon.image_132} alt="workspace" className="chat-window-popup-img" /> : <CiImageOn className="chat-window-popup-icon" />*/}
                <div className={`chat-window-popup-msg-content ${config?.workspaceStyles?.iconSetting2?.iconSetting === 'off' ? 'bubble-off' : ''}`}>
                    <div className="msg-popup" >
                        {config?.newMessageTitle ? 
                            <div className="msg-popup-column">
                                <h4>{config.newMessageTitle.length > LIMITS.newMessageTitle ? "Error" : config.newMessageTitle}</h4>
                                <p>{latestMessage?.text || latestMessage?.fileName}</p>
                            </div>
                            :
                            <p>{latestMessage?.text || latestMessage?.fileName}</p>
                        }
                    </div>
                    <button className="chat-window-popup-button" onClick={() => handleClick('open')}>
                        Chat With Us
                    </button>
                </div>
            </div>
            <button className='chat-icon-button' onClick={() => handleClick('close')}>
                <IoClose className="chat-icon" />
            </button>
        </>
    );
}

function IconButton({ toggleOpen, addMessage, config, messages, isWithinHours, isDeadEmbed, clearTrigger }) {
    const [isLoaded, setIsLoaded] = useState(false);
    const [showDeadMessage, setShowDeadMessage] = useState(false);

    useEffect(() => {
        // Trigger animation after component mounts
        setIsLoaded(true);
    }, []);

    //const styles = {};

    function getChosenIcon() {
        const defaultIcon = () => {
            // styles.background = 'transparent';
            // styles.backgroundImage = 'none';
            // styles.animation = 'none';
            return <PageParrotLogo className="chat-icon-logo" />; // default parrot icon
        }
        if (config?.workspaceStyles?.iconSetting1) {
            const { workspaceStyles } = config;
            switch(workspaceStyles.iconSetting1.iconSetting) {
                case "choose":
                    switch(workspaceStyles.iconSetting1.selectedIcon) {
                        case "chat1":
                            return <IoChatbubbleOutline className="chat-icon" />;
                        case "chat2":
                            return <IoChatbubblesOutline className="chat-icon" />;
                        default:
                            return defaultIcon();
                    }
                case "workspace":
                    switch(config?.workspaceType) {
                        case 0:
                            return ((config?.icon?.image_132) ? <img src={config.icon.image_132} alt="workspace" className="chat-icon rounded" /> : <PageParrotLogo className="chat-icon" />);
                        case 1:
                            return config?.icon ? <img src={config.icon} alt="workspace" className="chat-icon rounded" /> : <PageParrotLogo className="chat-icon" />;
                        case 2:
                            return config?.icon ? <img src={`https://cdn.discordapp.com/icons/${config?.workspace}/${config.icon}`} alt="workspace" className="chat-icon rounded" /> : <PageParrotLogo className="chat-icon" />;
                        default:
                            return defaultIcon();
                    }
                case "upload":
                    return <img src={workspaceStyles.customIcon} alt="workspace" className="chat-icon rounded" />;
                default:
                    return defaultIcon();
            }
        }
    }

    if (isDeadEmbed) {
        return (
            <>
                {showDeadMessage &&
                    <div className="dead-message">This chat is offline!</div>
                }
                <button 
                    className={`chat-icon-button ${isLoaded ? 'loaded' : 'unloaded'}`}
                    onClick={() => window.open('https://pageparrot.com/', '_blank')}
                    onMouseEnter={() => setShowDeadMessage(true)}
                    onMouseLeave={() => setShowDeadMessage(false)}
                    //style={styles}
                >
                    {getChosenIcon()}
                        {/*<img src="https://static.pageparrot.com/assets/SoloParrot6.svg" alt="workspace" className="chat-icon" />*/}
                </button>
            </>
        );
    }

    function handleClick() {
        clearTrigger();
        toggleOpen(true);
        if (messages.length === 0 && config.welcomeMsg) {
            addMessage({
                text: isWithinHours ? config.welcomeMsg : config.offlineWelcomeMsg,
                msgType: WELCOME_MSG,
                createdAt: Timestamp.now(),
                seen: false,
            });
        }
    }

    return(
        <button 
            className={`chat-icon-button hover-animation ${isLoaded ? 'loaded' : 'unloaded'}`}
            onClick={() => handleClick()}
            //style={styles}
        >
            {getChosenIcon()}
            {/*<img src="https://static.pageparrot.com/assets/SoloParrot6.svg" alt="workspace" className="chat-icon" />*/}
        </button>
    )
}

export default Chat;